/**
 * Resource that represents a Workstation.
 *
 * @name Workstation
 * @class
 * @augments TmrResource
 */
function WorkstationFactory(
  TmrResource,
  TmrLocalStorage,
  UserStorage,
  Antenna,
  Place
) {
  'ngInject'
  let actions = {
    /**
     * Gets the workstation of the currently logged in user.
     *
     * @method Workstation#getByLoggedUser
     * @throws Error if there is no logged user
     * @returns {Workstation}
     */
    getByLoggedUser: {
      method: 'GET',
      isArray: true,
      params: {
        'place.id': placeIdParam,
        orderBy: 'DESCRIPTION',
        asc: true,
      },
    },
    /**
     * Gets the active workstation.
     *
     * @method Workstation#getActive
     * @throws Error if there is no stored workstation id
     * @returns {Workstation}
     */
    getActive: {
      method: 'GET',
      params: {
        id: idParam,
      },
    },
  }

  let referencedProperties = [
    // workstation.antennas property will be instantiated as a Antenna resource
    { property: 'antennas', resource: Antenna },
    // workstation.place property will be instantiated as a Place resource
    { property: 'place', resource: Place },
  ]

  let defaultValues = () => ({
    antennas: [],
  })

  let Workstation = TmrResource(
    'Workstation',
    actions,
    referencedProperties,
    defaultValues
  )

  return Workstation

  function placeIdParam() {
    let loggedUser = UserStorage.getUserSync()

    if (!loggedUser) {
      throw new Error(
        'Trying to get logged user workstations but there is no logged user.'
      )
    }
    if (!loggedUser.place || !loggedUser.place.id) {
      throw new Error(
        'Trying to get logged user workstations but the user has no place.'
      )
    }
    return loggedUser.place.id
  }

  function idParam() {
    let id = TmrLocalStorage.get('workstation')
    if (!id) {
      throw new Error(
        'Trying to get active workstation but there is no selected workstation.'
      )
    }
    return id
  }
}

export const factory = ['Workstation', WorkstationFactory]
